export const tryParseJSON = jsonString =>{
  try {
    var o = JSON.parse(jsonString)
    if (o && typeof o === "object") {
        return o
    }
  }
  catch (e) { }

  return false
}

export const stringifyJSON = (jsonObj, replacer = null, space = 0) =>{
  if (jsonObj && typeof jsonObj === "object") {
    return JSON.stringify(jsonObj, replacer, space)
  }else{
    return jsonObj || ''
  }
}